import React from 'react';
import { Box } from '@mui/material';
import { useAuth } from 'contexts/AuthContext';
import CreateTeamUserForm from 'components/admin/CreateTeamUserForm';

const AdminContainer = ({ user }) => {
    const { authState } = useAuth();

    return (
        <Box sx={{ width: '100%', padding: 3 }}>
            <CreateTeamUserForm />
        </Box>
    );
};

export default AdminContainer;

